<template>
    <HeaderVue>
        <template #header>
            <div class="item-header">
                <slot name="before">
                    <div class="row">
                        <DxButton
                            class="custom-btn-white-color"
                            type="default"
                            icon="mdi mdi-chevron-left"
                            @click="$router.go(-1)"
                        />
                    </div>
                </slot>
            </div>
            <div class="item-header-center row justify-center">
                <slot name="center">
                    <div class="font-16 font-medium color-fff">Vé DN tự khai báo</div>
                </slot>
            </div>
            <div class="item-header">
                <slot name="after">
                    <div class="row">
                        <DxButton
                            type="default"
                            icon="mdi mdi-filter-variant"
                            class="ml-1"
                            @click="PopupLocDuLieu = true"
                        />
                    </div>
                </slot>
            </div>
        </template>
    </HeaderVue>

    <div class="row" style="padding-top: 48px"></div>

    <div class="mt-1 px-2">
        <DanhSachVeVue />
    </div>

    <PopupBottomVue
        v-model:dialog="PopupLocDuLieu"
        :closeOnOutsideClick="false"
        Title="Lọc dữ liệu bán vé"
        height="auto"
    >
        <template #content>
            <PopupLocDuLieuVue @hiddenPopup="hiddenPopup" />
        </template>
    </PopupBottomVue>
</template>
<script>
import HeaderVue from "@/components/Header/Header.vue";
import { DxButton } from "devextreme-vue";
import DanhSachVeVue from "./components/DanhSachVe.vue";
import PopupLocDuLieuVue from "./components/PopupLocDuLieu.vue";
import PopupBottomVue from "@/components/Popup/PopupBottom.vue";
export default {
    components: { HeaderVue, DxButton, DanhSachVeVue, PopupLocDuLieuVue, PopupBottomVue },
    props: {},
    data() {
        return { PopupLocDuLieu: false };
    },
    methods: {
        hiddenPopup(name) {
            this[name] = false;
        },
        showPopup(name) {
            this[name] = true;
        },
    },
    created() {},
    mounted() {},
};
</script>
<style scoped></style>
